import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { fmtErr } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/auth/set-password/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(fmtErr(e.response?.data?.detail))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Le password non coincidono");
    setBusy(true);
    try { await api.post("/auth/set-password", { token, password: pw }); toast.success("Password impostata: ora puoi accedere"); nav("/login"); }
    catch (e2) { toast.error(fmtErr(e2.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary/95 p-4" data-testid="set-password-page">
      <Card className="w-full max-w-md p-8 space-y-5">
        <div className="flex items-center gap-2 text-primary"><ShieldCheck className="w-7 h-7" /><span className="font-display font-bold text-xl">Capital Control — Portale Associati</span></div>
        {err ? <div className="text-destructive text-sm" data-testid="set-password-error">{err}</div> : !info ? <div className="text-muted-foreground text-sm">Verifica del link...</div> : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm">Benvenuto {info.name}. Imposta la password per l'account <strong>{info.email}</strong>.</p>
            <div><Label>Nuova password (min. 8 caratteri, lettere e numeri)</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="set-password-input" /></div>
            <div><Label>Conferma password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="set-password-confirm" /></div>
            <Button type="submit" className="w-full" disabled={busy} data-testid="set-password-submit">{busy ? "Salvataggio..." : "Imposta password e accedi"}</Button>
          </form>
        )}
      </Card>
    </div>
  );
}
